import { Colors, Fonts } from '../../shared/theme';
import { textStyles } from '../../shared/theme/fonts-ppv';

export const mainStyles = {
  uploadBox: {
    display: 'flex',
    height: '140px',
    justifyContent: 'flex-end',
    alignItems: 'flex-end'
  },
  upload: {
    borderStyle: 'solid',
    borderColor: Colors.violet600,
    borderRadius: '5px',
    borderWidth: '1px',
    backgroundColor: 'transparent',
    height: '40px',
    width: '84px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  box_name_Tooltip: {
    paddingTop: '14px',
    paddingLeft: '12px',
    ...textStyles.subtitle2,
    fontSize: Fonts.size.text14,
    color: Colors.white
  },
  box_prices_Tooltip: {
    paddingLeft: '16px',
    ...textStyles.subtitle2,
    fontSize: Fonts.size.text14,
    color: Colors.white
  },
  imageBox: {
    backgroundColor: '#F8F8F8',
    height: '140px',
    width: '140px'
  },
  paddingWarning: {
    paddingTop: '8px'
  },
  displayinline: {
    display: 'inline-block'
  },
  displayinline_left_13px: {
    display: 'inline-block',
    marginLeft: '13px'
  }
};

